module.exports = __webpack_public_path__ + "../resources/img/ic_re_hydro_unit_default.7d5ee99a.svg";